// Comissão de venda por quantidade de animais do lote (produto premium 'comissao_por_qtd').
// Faixas: [{ qtd_min, qtd_max (null = sem teto), percentual }]

export const percentualVendaPorQtd = (comissao, qtd) => {
  if (!comissao || comissao.tipo_comissao !== 'por_qtd') return null;
  const q = parseInt(qtd, 10) || 0;
  for (const f of comissao.faixas_qtd_venda || []) {
    if (q >= f.qtd_min && (f.qtd_max == null || q <= f.qtd_max)) return Number(f.percentual);
  }
  return null;
};

// Devolve a comissão com comissao_venda trocada pelo % da faixa do lote.
// Comissões que não são 'por_qtd' voltam exatamente as mesmas (sem impacto nelas).
export const aplicarFaixaQtd = (comissao, qtd) => {
  const pct = percentualVendaPorQtd(comissao, qtd);
  return pct == null ? comissao : { ...comissao, comissao_venda: pct };
};

export const textoFaixa = (f) =>
  f.qtd_max == null ? `Mais de ${f.qtd_min - 1} cabeças` : (f.qtd_min === f.qtd_max ? `${f.qtd_min} cabeça${f.qtd_min > 1 ? 's' : ''}` : `${f.qtd_min} a ${f.qtd_max} cabeças`);
